export default __webpack_public_path__ + "static/media/Front-end.8f7d9f69.jpg";